
import * as types from '../../mutation-types'
import {setItems, ftAPI} from '../../../util/helpers'
// import colors from 'vuetify/es5/util/colors'

// For color palette  see:
// https://vuetifyjs.com/en/style/colors
// and
// https://vuetifyjs.com/en/style/theme

const state = {
  version: '0.1.4', // Increment on every change!
  appMode: 'light', // Can be set to light or dark
  mainTabsSlider: 'yellow', // Default color
  switch: 'primary',
  pageBar: 'info',
  secondaryPageBar: 'info lighten-1',
  pageBarTabsColor: 'info', // Default color
  pageBarTabsSlider: 'info',
  inlineCircleClass: 'ft-inline-circle blue lighten-4 black--text',
  inlineCircleAltClass: 'ft-inline-circle green lighten-4 black--text',
  pageBarSaveButtonColor: 'primary',
  pageBarSaveDirtyButtonColor: 'success grey--text text--darken-3',
  pageBarWaitlistButtonColor: 'warning accent-4 grey--text text--darken-3',
  pageBarUnWaitlistButtonColor: 'warning accent-4 grey--text text--darken-3',
  light: {
    sectionTitle: 'grey lighten-3',
    sectionTitleError: 'error lighten-2'
  },
  dark: {
    sectionTitle: 'grey darken-4',
    sectionTitleError: 'error darken-2'
  },
  report: {
    table: 'font-family: "Trebuchet MS", "Open Sans", "Segoe UI", Tahoma, Helvetica, sans-serif;',
    caption: '',
    head: '',
    body: ''
  },
  reservation: {
    allergyIcon: 'mdi-alert-decagram',
    allergyColor: 'red',
    foodPreferenceColor: 'teal lighten-1',
    drinkPreferenceColor: 'blue lighten-2'
  }
}

const mutations = {
  [types.SET_STYLES] (state, styles) {
    setItems(state, styles, state)
    if (ftAPI && ftAPI()) ftAPI().setLastStyles(state)
  }
}

export default {
  state,
  mutations
}
